"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxisLabels = exports.YAxis = exports.StyledBarGraph = void 0;
var material_1 = require("@mui/material");
var Text_1 = __importDefault(require("shared/components/Text"));
exports.StyledBarGraph = (0, material_1.styled)('div', {
    shouldForwardProp: function (prop) { return prop !== 'isSelected'; },
})(function (_a) {
    var heightPX = _a.heightPX, isSelected = _a.isSelected, theme = _a.theme;
    return (__assign(__assign({ height: heightPX, width: '100%', padding: 0, margin: 0 }, (heightPX === 0 && {
        borderBottom: "1px solid  ".concat(isSelected ? '#ff95b5' : theme.palette.primary.light),
    })), { background: isSelected ? '#ffe2e8' : theme.palette.primary.light, borderTop: "2px solid ".concat(isSelected ? '#ff95b5' : 'transparent'), borderLeft: "2px solid ".concat(isSelected ? '#ff95b5' : 'transparent'), borderRight: "2px solid ".concat(isSelected ? '#ff95b5' : 'transparent'), borderTopLeftRadius: theme.spacing(0.5), borderTopRightRadius: theme.spacing(0.5), '&:hover': {
            background: '#ffe2e8',
        } }));
});
exports.YAxis = (0, material_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        color: '#555',
        position: 'absolute',
        textAlign: 'right',
        width: '100%',
        '& > div:not(.hidden)': {
            borderTop: "1px solid ".concat((_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.light),
            display: 'block',
            height: 40,
        },
        '& > div.hidden': {
            display: 'none',
        },
        '& > div:last-of-type': {
            borderTop: "2px solid ".concat(theme.palette.text.primary),
        },
    });
});
exports.AxisLabels = (0, material_1.styled)(Text_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        right: '-7%',
        top: -10,
        '& span': {
            marginBottom: theme.spacing(3),
            color: theme.palette.grey[600],
        },
    });
});
